'use strict';

angular.module('shiftTraderApp')
  .factory('UserCommunicationSubscriptions', function (ServerUrls, $q, $http) {
    var path = ServerUrls.current.railsApi + 'user_communication_subscriptions/';

    var UserCommunicationSubscription = function(initData) {
      var ucs = {};
      angular.extend(ucs, initData);

      ucs.shortType = ucs.type.slice(31); // Remove UserCommunicationSubscription:: class prefix from Rails STI

      ucs.$update = function(data) {
        var that = this;
        return $http.put(path + this.id, _.assign({organization_id: this.organization_id}, data))
          .then(function(response) {
            that.active = response.data.active;
            that.sms_enabled = response.data.sms_enabled;
            that.email_enabled = response.data.email_enabled;
            that.rules = response.data.rules;
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      ucs.$makeInactive = function() {
        var that = this;
        return this.$update({active: false})
          .then(function(response) {
            that.active = response.data.active;
            return response;
          }, function(response) {
            return $q.reject(response);
          });
      };

      ucs.$makeActive = function() {
        var that = this;
        return this.$update({active: true})
          .then(function(response) {
            that.active = response.data.active;
            return response;
          }, function(response) {
            return $q.reject(response);
          });
      };

      return ucs;
    };

    var UserCommunicationSubscriptions = {};

    UserCommunicationSubscriptions.getByUserId = function (userId, data) {
      var config = {
        params: {
          user_id: userId
        }
      };

      if (data) {
        _.extend(config.params, data);
      }

      return $http.get(path, config)
        .then(function (response) {
          return _.map(response.data, function(d) {
            return new UserCommunicationSubscription(d);
          });
        }, function(response) {
          console.log('UserCommunicationSubscriptions getByUserId failed');
          return $q.reject(response);
        });
    };

    UserCommunicationSubscriptions.create = function (attributes) {
      return $http.post(path, {'user_communication_subscription': attributes})
        .then(function (response) {
          return new UserCommunicationSubscription(response.data);
        }, function(response) {
          console.log('position created failed');
          return $q.reject(response);
        });
    };

    UserCommunicationSubscriptions.initWithData = function(data) {
      return new UserCommunicationSubscription(data);
    };

    return UserCommunicationSubscriptions;

  });
